var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_vm._v("After a visitor has scrolled "+_vm._s(_vm.data)+"% down on the current page.")])])}
var staticRenderFns = []

export { render, staticRenderFns }